import { resolveImagePath } from '@/utils/imageMap';

export function Services() {
  const services = [
    {
      id: 'music-lessons',
      title: 'Music Lessons for All ages',
      description: 'CMA offers music lessons on a variety of instruments for children, teens and adults. We have teachers who specialize in special needs students.',
      image: '/images/piano-keys-hand.jpg',
      linkText: 'the music studios',
      href: '/music-lessons'
    },
    {
      id: 'eastman-saxophones',
      title: 'Andreas Eastman Saxophones',
      description: 'We are proud to partner with Eastman Music Company and recommend them to students and others looking to purchase a quality instrument.',
      image: '/images/eastman-saxophones.jpg',
      linkText: 'andreas eastman',
      href: '/woodwinds-boutique'
    },
    {
      id: 'music-together',
      title: 'Music Together®',
      description: 'Join our community of families sharing songs, instrument play, rhythm chants, and movement activities in a relaxed, playful, non-performance setting.',
      image: '/images/music-together-illustration.jpg',
      linkText: 'Music Together®',
      href: '/music-together'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Three-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {services.map((service) => (
            <div key={service.id} className="text-center group">
              {/* Service Image */}
              <div className="mb-8">
                <img
                  src={resolveImagePath(service.image)}
                  alt={service.title}
                  loading="lazy"
                  className="w-full h-64 object-cover rounded-lg shadow-md group-hover:shadow-lg transition-shadow duration-300"
                />
              </div>

              {/* Service Content */}
              <div className="space-y-6 px-4">
                <h3 className="text-base font-semibold text-gray-900 font-subheading uppercase tracking-wide">
                  {service.title}
                </h3>

                <p className="text-lg text-gray-700 leading-relaxed font-body">
                  {service.description}
                </p>

                {/* Call-to-Action Button */}
                <div className="pt-2">
                  <a
                    href={service.href}
                    className="inline-block px-10 py-3.5 bg-white text-purple text-sm font-button border border-gray-300 rounded hover:bg-purple hover:text-white hover:border-purple transition-all duration-200 uppercase"
                  >
                    {service.linkText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}